<picture>
  @for(source of picturesSet; track source){
  <source [media]="source.media" [srcset]="source.srcset" />
  } @if (src) { @if(!isBase64()) {
  <img
    [ngSrc]="src"
    (error)="onErrorImage ? handleImgError($event, onErrorImage) : null"
    [class]="imgClass"
    [id]="imgId"
    [alt]="alt ?? ''"
    [width]="width"
    [height]="height"
  />
  }@else{
  <img
    [src]="src"
    (error)="onErrorImage ? handleImgError($event, onErrorImage) : null"
    [class]="imgClass"
    [id]="imgId"
    [alt]="alt ?? ''"
    [width]="width"
    [height]="height"
  />
  }}
</picture>
